import { createBrowserRouter } from "react-router-dom";
import { HomePage, ProjectsPage } from "../pages";
import { HubLayout } from "../layouts";

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <HubLayout />,
      children: [
        {
          index: true,
          element: <HomePage />,
        },
        {
          path: "projects",
          element: <ProjectsPage />,
        },
        // Future routes can be added here
        // e.g., { path: "settings", element: <SettingsPage /> },
        // e.g., { path: "profile", element: <ProfilePage /> },
      ],
    },
  ],
  {
    // URL Architecture Principle: Use first segment to identify app
    basename: "/home",
  }
);

export default router;
